var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackToWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1428 12.0423H0.857117M0.857117 12.0423L5.14283 7.75656M0.857117 12.0423L5.14283 16.328M21.4285 0.899414H17.1428C16.1961 0.899414 15.4285 1.66693 15.4285 2.6137V21.4708C15.4285 22.4176 16.1961 23.1851 17.1428 23.1851H21.4285C22.3753 23.1851 23.1428 22.4176 23.1428 21.4708V2.6137C23.1428 1.66693 22.3753 0.899414 21.4285 0.899414Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToWorkspace);
export default __webpack_public_path__ + "static/media/backToWorkspace.c43d090b56e6aa23f9634bfe6a466774.svg";
export { ForwardRef as ReactComponent };